"use client"

import {IconBtn} from "@/app/components/common/icon-btn/IconBtn";
import {PrevSvg} from "@/app/components/icons/PrevSvg";
import * as React from "react";
import {HTMLAttributes} from "react";
import {GoBackHeaderContainer} from "@/app/components/common/go-back-header/GoBackHeaderContainer";
import {useRouter} from "next/navigation";

interface IProps extends HTMLAttributes<HTMLDivElement> {
    title: string;
    iconBtnSize?: 'md' | 'lg'
}

export default function LinkedGoBackHeader ({className, title, iconBtnSize = 'md', ...props}: IProps) {
    const router = useRouter();

    const onBackClick = () => {
        router.back()
    }
    return (
        <GoBackHeaderContainer title={title} className={className} {...props}>
            <IconBtn onClick={onBackClick} size={iconBtnSize}>
                <PrevSvg/>
            </IconBtn>
        </GoBackHeaderContainer>
    )
}
